/* LIVVOLT · Jackery HomePower 3000 · adapters for the ported official detail markup.
   The official page upgrades custom elements with its own theme JS. This file provides
   the equivalent behaviour for the subset used on this page, scoped to the section root. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function initRoot(root) {
    if (root.dataset.hp3kOffReady) return;
    root.dataset.hp3kOffReady = 'true';

    var boxData = {};
    var dataNode = root.querySelector('[data-hp3k-box-data]');
    if (dataNode) {
      try { boxData = JSON.parse(dataNode.textContent); } catch (e) { boxData = {}; }
    }

    /* ---- 1. Accordions (<drop-down init="open">) ---- */
    root.querySelectorAll('drop-down').forEach(function (dd) {
      var trigger = dd.querySelector('[trigger]');
      var content = dd.querySelector('[trigger-content]');
      if (!trigger || !content) return;
      var isOpen = (dd.getAttribute('init') || '').indexOf('open') !== -1;
      function apply(open) {
        dd.setAttribute('open', open ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.hidden = !open;
        content.style.display = open ? '' : 'none';
        content.style.opacity = open ? '1' : '0';
      }
      apply(isOpen);
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        apply(dd.getAttribute('open') !== 'true');
      });
    });

    /* ---- 2. Tab blocks (4 Ways to Re-charge) ---- */
    root.querySelectorAll('.blocks-tabs-blocks').forEach(function (block) {
      var buttons = Array.prototype.slice.call(block.querySelectorAll('[data-tab-name]')).filter(function (el) {
        return el.tagName === 'BUTTON' || el.getAttribute('role') === 'tab';
      });
      var items = Array.prototype.slice.call(block.querySelectorAll('.blocks-tab-item'));
      if (!buttons.length || !items.length) return;
      function activate(name) {
        items.forEach(function (item) {
          var content = item.querySelector('[data-tab-name]');
          var key = content ? content.getAttribute('data-tab-name') : '';
          var active = key === name;
          item.classList.toggle('invisible', !active);
          item.style.display = active ? '' : 'none';
        });
        buttons.forEach(function (btn) {
          var active = btn.getAttribute('data-tab-name') === name;
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.classList.toggle('active', active);
        });
      }
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          activate(btn.getAttribute('data-tab-name'));
        });
      });
      activate(buttons[0].getAttribute('data-tab-name'));
    });

    /* ---- 3. Swiper-style carousels ---- */
    root.querySelectorAll('.swiper-wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.hp3kSwiped) return;
      wrapper.dataset.hp3kSwiped = 'true';
      var slides = wrapper.querySelectorAll(':scope > .swiper-slide');
      if (!slides.length) return;
      wrapper.style.display = 'flex';
      wrapper.style.overflowX = 'auto';
      wrapper.style.scrollSnapType = 'x mandatory';
      wrapper.style.scrollBehavior = 'smooth';
      wrapper.style.gap = '0';
      slides.forEach(function (slide) {
        slide.style.flex = '0 0 100%';
        slide.style.scrollSnapAlign = 'start';
        slide.style.minWidth = '0';
      });
      var scope = wrapper.closest('.swiper') || wrapper.parentElement;
      var prev = scope.parentElement.querySelector('.swiper-button-prev, .mb-swiper-button-prev, .left-icon');
      var next = scope.parentElement.querySelector('.swiper-button-next, .mb-swiper-button-next, .right-icon');
      function step(dir) {
        wrapper.scrollBy({ left: dir * wrapper.clientWidth, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
    });

    /* ---- 4. Runtime calculator (official formula and limits) ---- */
    root.querySelectorAll('.jky-v5-product-calculate').forEach(function (calc) {
      var container = calc.querySelector('.calculate-input');
      var addBtn = calc.querySelector('.calculate-add-text');
      var calcBtn = calc.querySelector('.calculate-button-text');
      var resultEl = calc.querySelector('.calculate-num');
      var errorEl = calc.querySelector('.calculate-error-text');
      if (!container || !resultEl) return;
      var capacity = parseFloat(calc.dataset.capacity) || 0;
      var efficiency = parseFloat(calc.dataset.efficiency) || 0.85;
      var ac = parseFloat(calc.dataset.ac_consumption) || 0;
      var maxPower = parseFloat(calc.dataset.max_power) || 0;

      function rows() { return container.querySelectorAll('.calculate-input-item'); }
      function calcNow() {
        var total = 0;
        rows().forEach(function (row) {
          var v = parseFloat(row.querySelector('input') && row.querySelector('input').value);
          if (!isNaN(v) && v > 0) total += v;
        });
        if (!total) { resultEl.textContent = '00'; if (errorEl) errorEl.classList.add('hidden'); return; }
        if (maxPower && total > maxPower) { resultEl.textContent = '00'; if (errorEl) errorEl.classList.remove('hidden'); return; }
        if (errorEl) errorEl.classList.add('hidden');
        var hours = (capacity * efficiency) / (total + ac);
        resultEl.textContent = hours.toFixed(1);
      }
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var first = rows()[0];
          if (!first || rows().length >= 5) return;
          var clone = first.cloneNode(true);
          var input = clone.querySelector('input');
          if (input) input.value = '';
          container.insertBefore(clone, container.querySelector('.calculate-error-text') || null);
          var label = clone.querySelector('.calculate-device');
          if (label) label.textContent = 'Device ' + rows().length + ':';
          if (rows().length >= 5) addBtn.style.display = 'none';
        });
      }
      if (calcBtn) calcBtn.addEventListener('click', calcNow);
      calc.addEventListener('input', calcNow);
      calcNow();
    });

    /* ---- 5. Lazy YouTube embeds (video carousel) ---- */
    root.querySelectorAll('viewport-youtube, iframe[data-src]').forEach(function (node) {
      var frame = node.tagName === 'IFRAME' ? node : node.querySelector('iframe');
      if (!frame) return;
      var src = frame.getAttribute('data-src') || frame.getAttribute('src');
      if (src && !frame.getAttribute('src')) frame.setAttribute('src', src);
      frame.setAttribute('loading', 'lazy');
    });

    /* ---- 6. What's in the box: official table is built by the official theme JS
           from data that is not present in the page HTML, so render our own list
           for the selected configuration instead of leaving an empty accordion. ---- */
    root.querySelectorAll('what-is-in-the-box').forEach(function (box) {
      var table = box.querySelector('.table-container');
      if (!table) return;
      table.innerHTML = '';
      var wrap = document.createElement('div');
      wrap.className = 'hp3k-boxlist';
      table.appendChild(wrap);
      function render(key) {
        var data = boxData[key] || boxData.basic || { title: key, items: [] };
        var html = '<h3>' + data.title + '</h3><ul>';
        data.items.forEach(function (item) { html += '<li>' + item + '</li>'; });
        html += '</ul><p class="hp3k-boxlist__note">Listed equipment follows the configuration selected in the purchase area above.</p>';
        wrap.innerHTML = html;
      }
      render('basic');
      root.addEventListener('hp3k:variant', function (event) {
        if (event.detail && event.detail.box) render(event.detail.box);
      });
      var select = box.querySelector('select[name="select-sku-variant-name"]');
      if (select) {
        select.addEventListener('change', function () {
          var name = select.options[select.selectedIndex].getAttribute('name') || '';
          var key = name.toLowerCase().indexOf('500') !== -1 ? 'solar500'
            : (name.toLowerCase().indexOf('200') !== -1 ? 'solar200' : 'basic');
          render(key);
        });
      }
    });

    /* ---- 7. In-page navigation anchors ---- */
    root.querySelectorAll('jky-navigation a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href').slice(1);
        var target = root.querySelector('[id="' + id + '"], [anchor-target="' + id + '"]');
        if (target) { event.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    /* ---- 8. Keep videos playing only when visible ---- */
    root.querySelectorAll('video').forEach(function (video) {
      video.muted = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { video.play().catch(function () {}); }
          else { video.pause(); }
        }, { rootMargin: '120px' }).observe(video);
      }
    });
  }

  function boot(scope) {
    scope.querySelectorAll('[data-hp3k-official]').forEach(initRoot);
  }

  ready(function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
